import React from 'react';
import { Roommate } from '@/types';
import { Favorite } from '@/components/Favorite';
import { BlockButton } from '@/components/BlockButton';

interface RoommateCardProps {
  roommate: Roommate;
  signedIn?: boolean;
  favorited?: boolean;
  blocked?: boolean;
  blockCallback?: () => void;
  showTypeBadge?: boolean;
}

export function RoommateCard({
  roommate,
  signedIn,
  favorited = false,
  blocked = false,
  blockCallback,
  showTypeBadge = false,
}: RoommateCardProps) {
  const carouselId = 'roommate-carousel' + roommate.id.toString();
  //const myCarousel = document.querySelector('#'+carouselId);
  //const carousel = new bootstrap.Carousel(myCarousel)

  return (
    <div className="card h-100 postable-card">
      {showTypeBadge && (
        <div className="housing-badges">
          <span className="housing-type-badge badge rounded-pill bg-primary">Roommate</span>
        </div>
      )}
      {typeof signedIn === 'boolean' && (
        <>
          <Favorite signedIn={signedIn} favoritableType="Roommate" favoritableId={roommate.id} favorited={favorited} />
          <BlockButton
            signedIn={signedIn}
            blockableType="Roommate"
            blockableId={roommate.id}
            blocked={blocked}
            noun="roommate profile"
            blockCallback={blockCallback}
          />
        </>
      )}
      <div
        className="carousel slide"
        data-bs-ride="carousel"
        style={{ height: '200px', overflow: 'hidden' }}
        id={carouselId}
      >
        <div className="carousel-inner bg-dark card-img-top" style={{ height: '200px' }}>
          {roommate.images.map((image, index) => (
            <div className={'carousel-item h-100 ' + (index === 0 ? 'active' : '')} key={image}>
              <a href={roommate.route_path} target="_blank" rel="noreferrer" className="d-block h-100">
                <img
                  src={image}
                  className="d-block w-100 h-100"
                  style={{ objectFit: 'cover' }}
                  alt={`${roommate.display_name}'s roommate profile`}
                />
              </a>
            </div>
          ))}
          {false && roommate.images.length > 1 && (
            <button className="carousel-control-prev" type="button" data-bs-slide="prev" data-bs-target={carouselId}>
              <span className="carousel-control-prev-icon" aria-hidden="true"></span>
              <span className="sr-only">Previous</span>
            </button>
          )}
          {false && roommate.images.length > 1 && (
            <button className="carousel-control-next" type="button" data-bs-slide="next" data-bs-target={carouselId}>
              <span className="carousel-control-next-icon" aria-hidden="true"></span>
              <span className="sr-only">Next</span>
            </button>
          )}
        </div>
      </div>
      <div className="card-body">
        <div className="card-title">
          <a href={roommate.route_path} target="_blank" rel="noreferrer">
            {roommate.display_name}'s roommate profile
          </a>
        </div>
        <div className="mb-2">
          {roommate.pronouns && (
            <span>
              Pronouns: {roommate.pronouns}
              <br />
            </span>
          )}
          {roommate.move_in && (
            <span>
              Move-in date: {roommate.move_in}
              <br />
            </span>
          )}
          {roommate.group_size && (
            <span>
              Group size: {roommate.group_size}
              <br />
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
